module.exports = __webpack_public_path__ + "img/14brsjb_05.1074f11f.jpg";